import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      es: {
        translation: esTranslations
      }
    },
    fallbackLng: 'en', // Default language if detection fails
    supportedLngs: ['en', 'es'],
    debug: false,
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      // Order of detection methods - prioritize querystring and localStorage
      order: ['querystring', 'localStorage', 'navigator'],
      // Keys to lookup language from
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'userLanguage',
      // Cache user language preference
      caches: ['localStorage'],
      // Cache key name
      lookupFromPathIndex: 0,
      checkWhitelist: true
    }
  });

export default i18n;
